<template>
    <div>
        <b-container fluid><b-row>
            <b-col>
                <b-card>
                    <CourseTable v-if="isCancelByCourse()"></CourseTable>
                    <BlockSequenceTable v-else></BlockSequenceTable>
                </b-card>
            </b-col>
            <b-col>
                <b-card>
                    <CourseTripsTable v-if="isCancelByCourse()"></CourseTripsTable>
                    <TripsTable v-else></TripsTable>
                </b-card>
            </b-col>
            <b-col>
                <b-card>
                    <PassingtimesTable></PassingtimesTable>
                </b-card>
            </b-col>
        </b-row></b-container>
    </div>
</template>

<script>
import trafficDeviations from '@/store/dispatching/trafficDeviations';
import BlockSequenceTable from '@/components/Dispatching/TrafficDeviations/BlockSequenceTable.vue';
import TripsTable from '@/components/Dispatching/TrafficDeviations/TripsTable.vue';
import CourseTable from '@/components/Dispatching/TrafficDeviations/CourseTable.vue';
import CourseTripsTable from '@/components/Dispatching/TrafficDeviations/CourseTripsTable.vue';
import PassingtimesTable from '@/components/Dispatching/TrafficDeviations/PassingtimesTable.vue';

export default {
    name: 'CanceledDepartures',
    components: { BlockSequenceTable, TripsTable, CourseTable, CourseTripsTable, PassingtimesTable },
    beforeCreate() {
        if (!this.$store.state.trafficDeviations) {
            this.$store.registerModule('trafficDeviations', trafficDeviations);
        }
        this.$store.commit('trafficDeviations/updateSelectedDate', '');
    },
    methods: {
        isCancelByCourse() {
            return this.$UiConfig('/ui/view/dispatching/canceleddepartures/cancelByCourse', false);
        }
    }
}
</script>
